import { deleteRequest, patchRequest, postRequest } from '../utils'

export type TapelineLineStyle = 'solid' | 'dashed' | 'dashed-long-gap'

export type PlanType = 'PositionPlan' | 'StiffeningPlan' | 'LoadPlan'

export interface PlanElementConfigDTO {
  storeysForPlans: string[]
  planTypes: PlanType[]
}

export interface TapelineTextDTO {
  start?: string
  end?: string
  center?: string
}

export interface TapelineStyleDTO {
  color: string
  thickness: number
  lineStyle: TapelineLineStyle
}

export interface TapelineCreateDTO {
  id?: string
  start: { x: number; y: number; z: number }
  end: { x: number; y: number; z: number }
  filterViewId: string
  text?: TapelineTextDTO | null
  style: TapelineStyleDTO
  showLengthLabel: boolean
  planConfig: PlanElementConfigDTO
}

export interface TapelineModifyDTO extends TapelineCreateDTO {
  id?: never
}

export interface TapelineDTO extends TapelineCreateDTO {
  id: string
  dateCreated: string
  dateModified: string
}

export const createTapelines: RequestTypeVariable = {
  getKey: (projectGuid: string) => ['createTapelines', projectGuid],
  request: async (projectGuid: string, tapelines: TapelineCreateDTO[]): Promise<TapelineDTO[]> => {
    const { data: result } = await postRequest<TapelineDTO[]>({
      url: `/projects/${projectGuid}/tapelines`,
      data: tapelines,
    })
    return result || []
  },
}

export const updateTapeline: RequestTypeVariable = {
  getKey: (projectGuid: string, tapelineId: string) => ['updateTapeline', projectGuid, tapelineId],
  request: async (
    projectGuid: string,
    tapelineId: string,
    data: TapelineModifyDTO,
  ): Promise<TapelineDTO[]> => {
    const { data: result } = await patchRequest<TapelineDTO[]>({
      url: `/projects/${projectGuid}/tapelines/${tapelineId}`,
      data,
    })
    return result || []
  },
}

export const deleteTapelines: RequestTypeVariable = {
  getKey: (projectGuid: string) => ['deleteTapelines', projectGuid],
  request: async (projectGuid: string, tapelineIds: string[]): Promise<TapelineDTO[]> => {
    const { data: result } = await deleteRequest<TapelineDTO[]>({
      url: `/projects/${projectGuid}/tapelines`,
      data: tapelineIds,
    })
    return result || []
  },
}
